import React, { useEffect, useState } from 'react';
import { useAuth } from '../../../../../providers/AuthContext';
import { useNavigate } from 'react-router-dom';
import { getWidgetById, getDataWidget, updateWidget } from '../../../../../services/apiWidgests';
import { useDashboards } from '../../../../../providers/DashboardContext';
import { connectToProcess } from '../../../../../services/sockets/processSocket';

import Spinner from '../../../../../components/Spinner';
import ComboBox from '../../../../../components/ComboBox';
import InputForm from '../../../../../components/InputForm';
import SelectionForm from '../../../../../components/SelectionForm';
import StacksIco from '../../../../../components/icons/StacksIco';
import FunctionsIco from '../../../../../components/icons/FunctionsIco';
import ArrowDownwardIco from '../../../../../components/icons/ArrowDownwardIco';
import ArrowUpwardIco from '../../../../../components/icons/ArrowUpwardIco';
import SkipNextIco from '../../../../../components/icons/SkipNextIco';
import SkipPreviousIco from '../../../../../components/icons/SkipPreviousIco';
import ArrowBack from '../../../../../components/icons/ArrowBack';
import ArrowForward from '../../../../../components/icons/ArrowForward';

function formatTime(value) {
  if (value == null || value === "") return "--";
  const totalSeconds = Number(value);
  const hours = Math.floor(totalSeconds / 3600).toString().padStart(2, "0");
  const minutes = Math.floor((totalSeconds % 3600) / 60).toString().padStart(2, "0");
  const seconds = (totalSeconds % 60).toString().padStart(2, "0");
  return `${hours}:${minutes}:${seconds}`;
}

function Pagination({ total, currentPage, maxPaginationPages, onChange }) {
  const totalPages = Math.ceil(total / maxPaginationPages);

  function getPagination(c, m, g) {
    if (g >= m) return Array.from({ length: m }, (_, i) => i + 1);
    let start, end;
    if (c <= Math.floor(g / 2)) {
      start = 1; end = g;
    } else if (c + Math.floor(g / 2) >= m) {
      start = m - g + 1; end = m;
    } else {
      start = c - Math.floor(g / 2);
      end = c + Math.floor(g / 2);
    }
    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
  }

  let arrayPages = getPagination(currentPage, totalPages, maxPaginationPages);

  return (
    <div className="flex gap-1">
      <button
        className={`mx-0.5 rounded-md min-w-6 h-6 bg-white ${currentPage !== 1 ? 'hover:bg-graysens' : 'cursor-not-allowed'}`}
        onClick={() => onChange(1)}
      ><SkipPreviousIco fill={currentPage !== 1 ? 'gray' : undefined} /></button>
      <button
        className={`mx-0.5 rounded-md min-w-6 h-6 bg-white ${currentPage !== 1 ? 'hover:bg-graysens' : 'cursor-not-allowed'}`}
        onClick={() => onChange(currentPage - 1 <= 1 ? 1 : currentPage - 1)}
      ><ArrowBack height="16px" width="16px" fill={currentPage !== 1 ? 'gray' : undefined} /></button>

      {arrayPages.map((element, index) => (
        <button
          key={index}
          className={`mx-0.5 rounded-md min-w-6 h-6 ${element === currentPage ? 'bg-bluesens text-white' : 'bg-white hover:bg-graysens'}`}
          value={element}
          onClick={(event) => onChange(Number(event.target.value))}
        >
          {element}
        </button>
      ))}

      <button
        className={`mx-0.5 rounded-md min-w-6 h-6 bg-white ${currentPage !== totalPages ? 'hover:bg-graysens' : 'cursor-not-allowed'}`}
        onClick={() => onChange(currentPage + 1 >= totalPages ? totalPages : currentPage + 1)}
      ><ArrowForward height="16px" width="16px" fill={currentPage !== totalPages ? 'gray' : undefined} /></button>
      <button
        className={`mx-0.5 rounded-md min-w-6 h-6 bg-white ${currentPage !== totalPages ? 'hover:bg-graysens' : 'cursor-not-allowed'}`}
        onClick={() => onChange(totalPages)}
      ><SkipNextIco fill={currentPage !== totalPages ? 'gray' : undefined} /></button>
    </div>
  );
}

export default function RegistersTableWidget({ id }) {
  const { auth } = useAuth();
  const navigate = useNavigate();
  const [conf, setConf] = useState({});
  const { dashboard, selectedDatarange } = useDashboards();

  const [registers, setRegisters] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsNumber, setRowsNumber] = useState(5);
  const [totalRegisters, setTotalRegister] = useState(0);
  const [fetchingWidgetInfo, setFetchingWidgetInfo] = useState(true);
  const [fetchingWidgetData, setFetchingWidgetData] = useState(true);
  const [triggerUpdate, setTriggerUpdate] = useState(false);

  // filtros
  const [filterField, setFilterField] = useState("");
  const [filterValue, setFilterValue] = useState("");

  const refreshWidgetInfo = async () => {
    try {
      setFetchingWidgetInfo(true);
      const widget = await getWidgetById(id, auth?.token);
      setConf(widget.configuration);
      setFetchingWidgetInfo(false);
    } catch (error) {
      console.log(error);
      setFetchingWidgetInfo(false);
      if (error?.response?.status === 404) console.log('Widget no encontrado');
      else if (error?.response?.status === 500) console.log('Error en el servidor, intente nuevamente');
      else navigate('/logout');
    }
  };

  const refreshWidgetData = async () => {
    try {
      setFetchingWidgetData(true);
      const widgetData = await getDataWidget(
        id,
        { currentPage, field: filterField, value: filterValue },
        auth?.token
      );
      setRegisters(widgetData.records || []);
      setTotalRegister(widgetData.totalRecords || 0);
      setRowsNumber(widgetData.rowsNumber || 5);
      setFetchingWidgetData(false);
    } catch (error) {
      console.log(error);
      setFetchingWidgetData(false);
      if (error?.response?.status === 404) console.log('Widget no encontrado');
      else if (error?.response?.status === 500) console.log('Error en el servidor, intente nuevamente');
      else navigate('/logout');
    }
  };

  const refreshWidgetDataSilent = async () => {
    try {
      
      const widgetData = await getDataWidget(
        id,
        { currentPage, field: filterField, value: filterValue },
        auth?.token
      );
      setRegisters(widgetData.records || []);
      setTotalRegister(widgetData.totalRecords || 0);
      setRowsNumber(widgetData.rowsNumber || 5);
      
    } catch (error) {
      console.log(error);
      
      if (error?.response?.status === 404) console.log('Widget no encontrado');
      else if (error?.response?.status === 500) console.log('Error en el servidor, intente nuevamente');
      else navigate('/logout');
    }
  };

  const updateConfigWidget = async () => {
    try {
      await updateWidget(id, { configuration: conf }, auth?.token);
      setTriggerUpdate(false);
      await refreshWidgetData();
    } catch (error) {
      console.log(error);
      setTriggerUpdate(false);
    }
  };

  const handleStackButton = async (index) => {
    let confTemp = { ...conf };
    confTemp.headers[index].stacked = !confTemp.headers[index].stacked;
    setConf(confTemp);
    setTriggerUpdate(true);
    await updateConfigWidget();
  };

  const handleSortHeader = async (index) => {
    let confTemp = { ...conf };
    const head = confTemp.headers[index].key;

    if (!confTemp.sortHeader) confTemp.sortHeader = {};
    if (typeof confTemp.sortHeader[head] !== 'undefined') {
      if (confTemp.sortHeader[head] === true) confTemp.sortHeader[head] = false;
      else confTemp.sortHeader = {};
    } else {
      confTemp.sortHeader = {};
      confTemp.sortHeader[head] = true;
    }

    setConf(confTemp);
    setTriggerUpdate(true);
    await updateConfigWidget();
  };

  const handlePagination = (selectedPage) => setCurrentPage(Number(selectedPage));

  const handleRowSelection = (event) => {
    let confTemp = { ...conf };
    confTemp.rowsNumber = Number(event.currentTarget.value);
    setConf(confTemp);
    setTriggerUpdate(true);
    updateConfigWidget();
  };

  const handleReorderHeaders = (startIndex, endIndex) => {
    const newHeaders = Array.from(conf.headers);
    const [moved] = newHeaders.splice(startIndex, 1);
    newHeaders.splice(endIndex, 0, moved);
    setConf((prev) => ({ ...prev, headers: newHeaders }));
    setTriggerUpdate(true);
    updateConfigWidget();
  };

  const handleFilterFieldChange = (displayNameOrAlias) => {
    const selectedHeader = conf.headers?.find(
      (h) => (h.displayName || h.alias || h.key) === displayNameOrAlias
    );
    if (selectedHeader) setFilterField(selectedHeader.key);
  };

  const handleFilterValueChange = (value) => setFilterValue(value);

  useEffect(() => {
    refreshWidgetInfo();
    refreshWidgetData();
  }, [selectedDatarange]);

  // 🔹 Socket de actualizaciones
  useEffect(() => {
    if (!conf?.process?.id) return;

    const disconnect = connectToProcess(
      conf.process.id,
      process.env.REACT_APP_SOCKET_URL,
      () => {
        // Refresh transparente al recibir update
        refreshWidgetDataSilent();
      }
    );

    return () => disconnect();
  }, [conf?.process?.id]);

  useEffect(() => {
    if (conf.headers) refreshWidgetData();
  }, [conf, currentPage, filterField, filterValue]);

  useEffect(() => {
    if (triggerUpdate) updateConfigWidget();
  }, [triggerUpdate]);

  const renderCell = (row, headerItem) => {
    const key = headerItem.displayName || headerItem.alias || headerItem.key;
    let value = row[key];
    if (headerItem.type === 'time' && value != null) return formatTime(value);
    if (value === "" || value == null) return "--";
    return value === 0 ? 0 : value;
  };

  return (
    <div className="flex flex-col h-full border">
      {/* Header Fijo: filtros + columnas */}
      <div className="flex flex-col flex-shrink-0">
        {/* Filtros */}
        {!fetchingWidgetInfo && (
          <div className="flex justify-between gap-2 p-1 border-b bg-white">
            <div className="flex-1 mr-2">
              <InputForm
                text="Buscar"
                enabled={conf.headers?.length > 0 && filterField}
                onChange={(e) => handleFilterValueChange(e.target.value)}
                AppendClassName='-mb-5'
              />
            </div>
            <div className="w-40 relative">
              <SelectionForm
                text="Campo"
                options={conf.headers?.map((h) => h.displayName || h.alias || h.key)}
                onChange={handleFilterFieldChange}
                enabled={conf.headers?.length > 0}
                AppendClassName='-mb-5'
              />
            </div>
          </div>
        )}

        {/* Header de columnas */}
        {!fetchingWidgetInfo && (
          <div
            className="grid text-gray-500 font-semibold p-1 border-b border-gray-300 bg-white sticky top-[48px] shadow"
            style={{ gridTemplateColumns: `repeat(${conf.headers.length}, minmax(0, 1fr))` }}
            onDragOver={(e) => e.preventDefault()}
          >
            {conf.headers?.map((headerItem, index) => (
              <div
                key={index}
                draggable
                data-header-id={id}
                onDragStart={(e) => {
                  e.dataTransfer.setData('headerIndex', index);
                  e.dataTransfer.setData('sourceComponent', id);
                }}
                onDrop={(e) => {
                  const startIndex = e.dataTransfer.getData('headerIndex');
                  const sourceComponent = e.dataTransfer.getData('sourceComponent');
                  if (sourceComponent === id) handleReorderHeaders(Number(startIndex), index);
                }}
                className="p-2 mx-auto text-xs text-center"
              >
                <div className="flex gap-1 items-center justify-center">
                  {(headerItem.type === 'numeric' || headerItem.type === 'time') && (
                    <button onClick={() => handleStackButton(index)}>
                      <FunctionsIco fill={headerItem.stacked ? '#0d0df7' : 'darkgray'} />
                    </button>
                  )}
                  {!headerItem.type && (
                    <button onClick={() => handleStackButton(index)}>
                      <StacksIco fill={headerItem.stacked ? '#0d0df7' : 'darkgray'} />
                    </button>
                  )}
                  <button onClick={() => handleSortHeader(index)}>{headerItem.displayName}</button>
                  {conf.sortHeader && typeof conf.sortHeader[headerItem.key] !== 'undefined' && (
                    <>
                      {conf.sortHeader[headerItem.key] === true && (
                        <ArrowUpwardIco width="20px" height="20px" fill="darkgray" />
                      )}
                      {conf.sortHeader[headerItem.key] === false && (
                        <ArrowDownwardIco width="20px" height="20px" fill="darkgray" />
                      )}
                    </>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Body Scrollable */}
      <div className="flex-1 overflow-auto">
        {!fetchingWidgetData && registers.length > 0 ? (
          registers.map((row, rowIndex) => (
            <div
              key={rowIndex}
              className="grid px-2 py-1 hover:bg-graysens"
              style={{ gridTemplateColumns: `repeat(${conf.headers?.length}, minmax(0, 1fr))` }}
            >
              {conf.headers?.map((headerItem, colIndex) => (
                <div key={colIndex} className="p-1 text-center">
                  {renderCell(row, headerItem)}
                </div>
              ))}
            </div>
          ))
        ) : (
          <div className="w-full h-full flex justify-center items-center text-gray-500">
            {fetchingWidgetData ? <Spinner /> : "No hay registros"}
          </div>
        )}
      </div>

      {/* Footer */}
      {!fetchingWidgetData && !fetchingWidgetInfo && (
        <section
          id="footer"
          className="flex-shrink-0 w-full shadow-md border-t bg-white mb-10"
        >
          <div className="flex justify-between py-3 w-full px-3">
            <div className="text-sm text-gray-500">{totalRegisters} total</div>
            <div>
              <ComboBox
                value={rowsNumber}
                label={'resultados por página'}
                options={[5, 10, 15, 20, 25, 30]}
                onChange={handleRowSelection}
              />
            </div>
            <div>
              <Pagination
                total={totalRegisters}
                currentPage={currentPage}
                maxPaginationPages={conf.rowsNumber}
                onChange={handlePagination}
              />
            </div>
          </div>
        </section>
      )}
    </div>
  );
}
